<template>
  <footer class="page-footer" :class="{ inline }">
    <slot />
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  props: {
    /**
     * インライン表示（スタイルガイド用）
     * @ignore
     */
    inline: { type: Boolean, default: false },
  },
}
</script>

<style lang="postcss" scoped>
.page-footer {
  background-color: var(--mostly-white);
  bottom: 0;
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 16px;
  height: 72px;
  justify-content: space-between;
  min-width: 320px;
  padding: 8px;
  position: fixed;
  width: 100%;
  z-index: 8;

  &.inline {
    position: static;
  }

  >>> .button {
    width: 192px;
  }

  .responsive & {
    @media screen and (max-width: 639px) {
      grid-auto-columns: 1fr;
      justify-content: center;
      padding: 16px;

      >>> .button {
        font-size: 15px;
        height: 40px;
        line-height: 40px;
        width: 100%;
      }
    }
  }
}
</style>
